// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"254":"c76e721d","415":"c39111f7","825":"fe768adc","872":"3f538886","924":"c76e721d"}[chunkId] + ".css";
};